export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2021.3e5cb470.pdf";